/*
LUCID LOOM — STEP 65 HOTFIX
SAFE INSTANT CART OPEN

EINBAUORT:
Onlineshop → Themes → … → Code bearbeite
→ Assets → ll-cart-drawer.js

KOMPLETTE DATEI ERSETZEN.

WICHTIG:
Die zuvor erstellten Step65-Dateien NICHT weiter verwenden:
- ll-cart-drawer-bootstrap.js wird NICHT benötigt
- Sections/cart-drawer.liquid muss wieder auf Step64-Stand sein
- ll-premium-header.js muss wieder auf Step64-Stand sein

DIESE HOTFIX-VERSION:
- basiert vollständig auf dem funktionierenden Step64-Theme
- ändert NUR Assets/ll-cart-drawer.js
- normaler Cart-Icon-Klick startet die vorhandene Motion sofort
- 120ms Bild-Prewarm läuft erst danach
- Quick Add / Payload-Open behält den alten sicheren Ablauf
- OPEN_MS 740ms / CLOSE_MS 960ms unverändert
*/
/*
LUCID LOOM — STEP 38
EINBAUORT IN SHOPIFY:
Onlineshop → Themes → … → Code bearbeiten → Assets → ll-cart-drawer.js

WAS TUN:
Neue JS-Datei namens ll-cart-drawer.js anlegen.
Falls sie bereits existiert: den KOMPLETTEN Inhalt ersetzen.

ENTHÄLT:
Cart-AJAX / Section-Refresh / Quick-Add-Bridges / Cart-Events / WhatsApp-Link-Logik.

WICHTIG:
Assets/ll-cart-ajax-shared.js NICHT ersetzen oder löschen.
*/
(function() {
  if (window.__LLCartDrawerCleanFinalAjaxV1) return;
  window.__LLCartDrawerCleanFinalAjaxV1 = true;

  const ROOT_SELECTOR = '[data-ll-cart-drawer-root][data-section-id]';
  const configNode = document.querySelector('[data-ll-cart-drawer-config]');
  if (!configNode) return;

  let drawerConfig = null;

  try {
    drawerConfig = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    console.error('[Lucid Loom] Cart drawer config could not be parsed.', error);
    return;
  }

  const MONEY_FORMAT = drawerConfig.moneyFormat;
  const SHOP_CURRENCY = drawerConfig.shopCurrency;
  const CART_ADD_URL = drawerConfig.cartAddUrl;

  if (!MONEY_FORMAT || !SHOP_CURRENCY || !CART_ADD_URL) return;
  const FREE_SHIP_THRESHOLD = 10000;
  const STRUCTURE_PATCH_DELAY = 120;
  const OPEN_IMAGE_PREWARM_TIMEOUT = 180;

  let sectionPatchTimer = null;
  let sectionPatchRunning = false;
  let queuedSectionCart = null;
  let queuedSectionOpen = false;
  let lastKnownCart = null;
  let lastSectionSignature = '';
  let lastJsonPatchSignature = '';
  let lastInteractionAt = 0;

  function root() {
    return document.querySelector('cart-drawer-component ' + ROOT_SELECTOR);
  }

  function drawerComponent() {
    return document.querySelector('cart-drawer-component');
  }

  function dialog() {
    return document.querySelector('cart-drawer-component dialog');
  }

  function isOpen() {
    const d = dialog();
    return !!(d && d.hasAttribute('open'));
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function parseHTML(html) {
    if (window.LLCartAjax && typeof window.LLCartAjax.parseHTML === 'function') {
      return window.LLCartAjax.parseHTML(html);
    }

    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content;
  }

  function sectionRootFromHTML(html) {
    const parsed = parseHTML(html);
    return (
      parsed.querySelector(ROOT_SELECTOR) ||
      parsed.querySelector('cart-items-component[data-section-id]') ||
      parsed.querySelector('.cart-items-component[data-section-id]')
    );
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, Math.max(0, Number(ms || 0))));
  }

  function imageSourcesFromScope(scope) {
    if (!scope || !scope.querySelectorAll) return [];

    const sources = [];
    const seen = new Set();

    scope.querySelectorAll('img').forEach((img) => {
      const src = img.currentSrc || img.getAttribute('src') || '';

      if (src && !seen.has(src)) {
        seen.add(src);
        sources.push(src);
      }

      try {
        if (img.loading !== 'eager') img.loading = 'eager';
        if (img.decoding !== 'async') img.decoding = 'async';
        if (img.getAttribute('loading') !== 'eager') img.setAttribute('loading', 'eager');
        if (img.getAttribute('decoding') !== 'async') img.setAttribute('decoding', 'async');
        if (img.getAttribute('fetchpriority') !== 'low') img.setAttribute('fetchpriority', 'low');
      } catch (error) {}
    });

    return sources;
  }

  function preloadImageSource(src) {
    return new Promise((resolve) => {
      if (!src) {
        resolve();
        return;
      }

      const image = new Image();
      let done = false;

      const finish = () => {
        if (done) return;
        done = true;

        if (image.decode) {
          image.decode().then(resolve).catch(resolve);
        } else {
          resolve();
        }
      };

      image.onload = finish;
      image.onerror = finish;

      try {
        image.loading = 'eager';
        image.decoding = 'async';
      } catch (error) {}

      image.src = src;
      if (image.complete) finish();
    });
  }

  async function prewarmDrawerImages(scope, timeoutMs) {
    const sources = imageSourcesFromScope(scope).slice(0, 8);
    if (!sources.length) return;

    await Promise.race([
      Promise.allSettled(sources.map(preloadImageSource)),
      wait(timeoutMs || OPEN_IMAGE_PREWARM_TIMEOUT)
    ]);
  }

  function cartDisplaySubtotal(cart) {
    if (!cart) return 0;

    if (typeof cart.items_subtotal_price !== 'undefined' && cart.items_subtotal_price !== null) {
      return Number(cart.items_subtotal_price || 0);
    }

    if (Array.isArray(cart.items)) {
      return cart.items.reduce((sum, item) => {
        return sum + Number(item.final_line_price || item.line_price || 0);
      }, 0);
    }

    return 0;
  }

  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';

    return [
      cart.item_count || 0,
      cartDisplaySubtotal(cart),
      cart.items.map((item) => [
        item.key,
        item.quantity,
        item.final_line_price || item.line_price || 0
      ].join(':')).join('|')
    ].join('::');
  }

  function money(cents, cart) {
    const value = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(value, MONEY_FORMAT);
      } catch (error) {}
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: (cart && cart.currency) || SHOP_CURRENCY || 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (error) {
      return (value / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function setText(el, text) {
    if (!el) return;
    const next = String(text == null ? '' : text);
    if (el.textContent !== next) el.textContent = next;
  }

  function setHTML(el, html) {
    if (!el) return;
    const next = String(html == null ? '' : html);
    if (el.innerHTML !== next) el.innerHTML = next;
  }

  function syncAttributes(target, source) {
    if (!target || !source) return;

    Array.from(target.attributes).forEach((attr) => {
      if (!source.hasAttribute(attr.name)) {
        target.removeAttribute(attr.name);
      }
    });

    Array.from(source.attributes).forEach((attr) => {
      if (target.getAttribute(attr.name) !== attr.value) {
        target.setAttribute(attr.name, attr.value);
      }
    });
  }

  function itemIdentity(item) {
    if (!item) return '';

    const key = item.getAttribute('data-item-key');
    if (key) return 'item:' + key;

    if (item.getAttribute('data-sticker-item') === 'true') {
      const pseudoId = item.getAttribute('data-pseudo-product-id') || '';
      return pseudoId ? 'sticker:' + pseudoId : '';
    }

    return '';
  }

  function currentRealRows() {
    return Array.from(document.querySelectorAll('cart-drawer-component .cart-item[data-item-key]'));
  }

  function currentRealKeys() {
    return currentRealRows().map((row) => row.getAttribute('data-item-key')).filter(Boolean);
  }

  function cartKeys(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map((item) => item.key).filter(Boolean);
  }

  function sameKeySet(cart) {
    const dom = currentRealKeys().sort();
    const next = cartKeys(cart).sort();

    if (dom.length !== next.length) return false;
    return dom.every((key, index) => key === next[index]);
  }

  function getCartItem(cart, key) {
    if (!cart || !Array.isArray(cart.items) || !key) return null;
    return cart.items.find((item) => item.key === key) || null;
  }

  async function fetchCart() {
    if (window.LLCartAjax && typeof window.LLCartAjax.fetchCart === 'function') {
      try {
        const cart = await window.LLCartAjax.fetchCart();
        if (cart) return cart;
      } catch (error) {}
    }

    const response = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  }

  async function changeQuantityDirect(itemKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: Math.max(0, Number(quantity || 0))
      })
    });

    if (!response.ok) throw new Error('Cart change failed');
    return response.json();
  }

  function syncGlobalBubble(cart) {
    if (!cart) return;

    if (window.LLCartAjax && typeof window.LLCartAjax.syncGlobalBubbleCount === 'function') {
      try {
        window.LLCartAjax.syncGlobalBubbleCount(cart);
        return;
      } catch (error) {}
    }

    document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"], .cart-count-bubble .visually-hidden').forEach((el) => {
      if (el.matches && el.matches('.visually-hidden')) {
        setText(el, cart.item_count + ' Artikel');
      } else {
        setText(el, cart.item_count || 0);
      }
    });
  }

  function updateHeader(cart) {
    const count = document.querySelector('cart-drawer-component .cart-count');
    if (count) setText(count, cart.item_count || 0);
  }

  function updateSummary(cart) {
    const subtotalCents = cartDisplaySubtotal(cart);
    const total = document.querySelector('cart-drawer-component .cart-drawer__total');
    setText(total, money(subtotalCents, cart));

    let note = document.querySelector('cart-drawer-component .cart-drawer__note');
    const remaining = Math.max(FREE_SHIP_THRESHOLD - subtotalCents, 0);
    const percent = Math.max(0, Math.min(100, ((subtotalCents / FREE_SHIP_THRESHOLD) * 100)));

    if (note) {
      note.remove();
    }

    const title = document.querySelector('cart-drawer-component .lucid-freeship__title');
    const fill = document.querySelector('cart-drawer-component .lucid-freeship__fill');
    const text = document.querySelector('cart-drawer-component .lucid-freeship__text');
    const zone = document.querySelector('cart-drawer-component .lucid-freeship__zone');
    const threshold = document.querySelector('cart-drawer-component .lucid-freeship__threshold');

    if (zone) zone.hidden = remaining === 0;
    if (threshold) threshold.hidden = remaining === 0;

    if (remaining === 0) {
      setHTML(title, '<span>GRATIS VERSAND</span>');
      setHTML(text, '');
    } else {
      setHTML(title, '<span>VERSAND</span>');
      setHTML(text, '<span class="lucid-freeship__remaining"><strong>' + money(remaining, cart) + '</strong> bis GRATIS VERSAND</span>');
    }

    if (fill) {
      const nextWidth = percent + '%';
      if (fill.style.width !== nextWidth) {
        requestAnimationFrame(function(){ fill.style.width = nextWidth; });
      }
    }
  }

  function updateRealRowFromCart(item) {
    if (!item || !item.key) return false;

    const row = document.querySelector('cart-drawer-component .cart-item[data-item-key="' + cssEscape(item.key) + '"]');
    if (!row) return false;

    const qty = row.querySelector('.qty-inline-display');
    const price = row.querySelector('.cart-item__price');
    const minus = row.querySelector('.qty-inline-btn[data-delta="-1"]');

    setText(qty, item.quantity || 0);
    setText(price, money(item.final_line_price || item.line_price || 0, lastKnownCart));

    if (minus) {
      minus.setAttribute('aria-label', Number(item.quantity || 0) <= 1 ? 'Artikel entfernen' : 'Menge verringern');
    }

    return true;
  }

  function collapseAndRemove(row) {
    if (!row || row.__llZeroReloadRemoving) return;

    row.__llZeroReloadRemoving = true;

    const height = row.offsetHeight;
    row.style.height = height + 'px';
    row.style.overflow = 'hidden';
    row.style.willChange = 'height, opacity, transform, padding, margin';

    requestAnimationFrame(() => {
      row.classList.add('ll-cart-item-collapsing');
      row.style.height = '0px';
      row.style.paddingTop = '0px';
      row.style.paddingBottom = '0px';
      row.style.marginTop = '0px';
      row.style.marginBottom = '0px';
    });

    window.setTimeout(() => {
      if (row && row.parentNode) {
        row.parentNode.removeChild(row);
      }
    }, 210);
  }

  function removeRowsNotInCart(cart) {
    const keys = new Set(cartKeys(cart));

    currentRealRows().forEach((row) => {
      const key = row.getAttribute('data-item-key');

      if (key && !keys.has(key)) {
        collapseAndRemove(row);
      }
    });
  }

  function updateStickerRows(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    document.querySelectorAll('cart-drawer-component .cart-item[data-sticker-item="true"][data-pseudo-product-id]').forEach((sticker) => {
      const productId = Number(sticker.getAttribute('data-pseudo-product-id') || 0);
      if (!productId) return;

      const qty = cart.items.reduce((sum, item) => {
        return Number(item.product_id || 0) === productId ? sum + Number(item.quantity || 0) : sum;
      }, 0);

      if (qty <= 0) {
        collapseAndRemove(sticker);
        return;
      }

      setText(sticker.querySelector('.sticker-qty'), qty);
    });
  }

  function applyJsonOnly(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    lastKnownCart = cart;

    const signature = cartSignature(cart);

    if (signature && signature === lastJsonPatchSignature && Date.now() - lastInteractionAt > 80) {
      return true;
    }

    cart.items.forEach(updateRealRowFromCart);
    removeRowsNotInCart(cart);
    updateHeader(cart);
    updateSummary(cart);
    updateStickerRows(cart);
    syncGlobalBubble(cart);

    lastJsonPatchSignature = signature;

    document.dispatchEvent(new CustomEvent('cart-drawer:rendered', {
      bubbles: true,
      detail: {
        cart: cart,
        mode: 'json-only-clean-final'
      }
    }));

    return true;
  }

  function shouldUseFullEmptySwap(cart) {
    const r = root();
    if (!r) return false;

    const currentEmpty = !!r.querySelector('.cart-drawer__empty') && !r.querySelector('.cart-drawer__items');
    const nextEmpty = !cart || !Array.isArray(cart.items) || Number(cart.item_count || 0) <= 0;

    return currentEmpty !== nextEmpty;
  }

  function patchElementHTML(current, fresh, selector) {
    const currentEl = current.querySelector(selector);
    const freshEl = fresh.querySelector(selector);

    if (!currentEl && freshEl) return;

    if (currentEl && !freshEl) {
      currentEl.remove();
      return;
    }

    if (!currentEl || !freshEl) return;

    syncAttributes(currentEl, freshEl);

    if (currentEl.innerHTML !== freshEl.innerHTML) {
      currentEl.innerHTML = freshEl.innerHTML;
    }
  }

  function patchElementText(current, fresh, selector) {
    const currentEl = current.querySelector(selector);
    const freshEl = fresh.querySelector(selector);

    if (!currentEl || !freshEl) return;

    syncAttributes(currentEl, freshEl);

    if (currentEl.textContent !== freshEl.textContent) {
      currentEl.textContent = freshEl.textContent;
    }
  }

  function patchImageShell(current, fresh) {
    const currentLink = current.querySelector('.cart-item__image-link');
    const freshLink = fresh.querySelector('.cart-item__image-link');

    if (currentLink && freshLink) {
      syncAttributes(currentLink, freshLink);
    }

    const currentImg = current.querySelector('.cart-item__image');
    const freshImg = fresh.querySelector('.cart-item__image');

    if (!currentImg || !freshImg) return;

    ['alt', 'loading', 'decoding', 'width', 'height'].forEach((attr) => {
      const freshValue = freshImg.getAttribute(attr);

      if (freshValue === null) {
        currentImg.removeAttribute(attr);
      } else if (currentImg.getAttribute(attr) !== freshValue) {
        currentImg.setAttribute(attr, freshValue);
      }
    });
  }

  function patchCartItem(current, fresh) {
    if (!current || !fresh) return;

    syncAttributes(current, fresh);
    current.className = fresh.className;

    patchImageShell(current, fresh);
    patchElementHTML(current, fresh, '.cart-item__title-link');
    patchElementHTML(current, fresh, '.cart-item__variant');
    patchElementHTML(current, fresh, '.cart-item__gift-badge');
    patchElementText(current, fresh, '.cart-item__price');
    patchElementText(current, fresh, '.qty-inline-display');

    const currentQtyForm = current.querySelector('.inline-qty-form');
    const freshQtyForm = fresh.querySelector('.inline-qty-form');

    if (currentQtyForm && freshQtyForm) {
      syncAttributes(currentQtyForm, freshQtyForm);
    }

    const currentRemove = current.querySelector('.remove-btn[data-remove-key]');
    const freshRemove = fresh.querySelector('.remove-btn[data-remove-key]');

    if (currentRemove && freshRemove) {
      syncAttributes(currentRemove, freshRemove);
    }
  }

  function patchItems(currentItems, freshItems) {
    if (!currentItems || !freshItems) return false;

    const currentMap = new Map();

    Array.from(currentItems.querySelectorAll(':scope > .cart-item')).forEach((item) => {
      const id = itemIdentity(item);
      if (id) currentMap.set(id, item);
    });

    const freshList = Array.from(freshItems.querySelectorAll(':scope > .cart-item'));
    const used = new Set();
    let previousNode = null;

    freshList.forEach((freshItem) => {
      const id = itemIdentity(freshItem);
      let node = id ? currentMap.get(id) : null;

      if (node) {
        used.add(id);
        patchCartItem(node, freshItem);
      } else {
        node = freshItem.cloneNode(true);
        node.classList.add('ll-cart-item-entering');

        requestAnimationFrame(() => {
          node.classList.remove('ll-cart-item-entering');
        });
      }

      const expectedNext = previousNode ? previousNode.nextSibling : currentItems.firstChild;

      if (node !== expectedNext) {
        currentItems.insertBefore(node, expectedNext);
      }

      previousNode = node;
    });

    Array.from(currentItems.querySelectorAll(':scope > .cart-item')).forEach((item) => {
      const id = itemIdentity(item);

      if (id && currentMap.has(id) && !used.has(id)) {
        collapseAndRemove(item);
      }
    });

    return true;
  }

  function patchHeader(currentHeader, freshHeader) {
    if (!currentHeader || !freshHeader) return;

    const currentCount = currentHeader.querySelector('.cart-count');
    const freshCount = freshHeader.querySelector('.cart-count');

    if (currentCount && freshCount) {
      setText(currentCount, freshCount.textContent);
      return;
    }

    if (currentHeader.innerHTML !== freshHeader.innerHTML) {
      currentHeader.innerHTML = freshHeader.innerHTML;
    }
  }

  function patchSummary(currentSummary, freshSummary) {
    if (!currentSummary || !freshSummary) return;

    const selectors = [
      '.cart-drawer__total',
      '.lucid-freeship__title',
      '.lucid-freeship__fill',
      '.lucid-freeship__text',
      '.checkout-main-btn',
      '.lucid-help-links',
      '.lucid-trustline'
    ];

    selectors.forEach((selector) => {
      const currentEl = currentSummary.querySelector(selector);
      const freshEl = freshSummary.querySelector(selector);

      if (!currentEl && freshEl) {
        const total = currentSummary.querySelector('.cart-drawer__total');

        return;
      }

      if (currentEl && !freshEl) {
        currentEl.remove();
        return;
      }

      if (!currentEl || !freshEl) return;

      syncAttributes(currentEl, freshEl);

      if (selector === '.lucid-freeship__fill') {
        currentEl.style.width = freshEl.style.width;
      } else if (currentEl.innerHTML !== freshEl.innerHTML) {
        currentEl.innerHTML = freshEl.innerHTML;
      }
    });
  }

  async function fetchSectionRoot() {
    const r = root();
    if (!r) return null;

    const sectionId = r.getAttribute('data-section-id');
    if (!sectionId) return null;

    let html = '';

    if (window.LLCartAjax && typeof window.LLCartAjax.fetchSectionHtml === 'function') {
      html = await window.LLCartAjax.fetchSectionHtml(sectionId);
    } else {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control': 'no-cache'
        }
      });

      if (!response.ok) throw new Error('Section fetch failed');

      html = await response.text();
    }

    return sectionRootFromHTML(html);
  }

  async function patchSection(cart, options) {
    const r = root();
    if (!r) return;

    if (cart && !shouldUseFullEmptySwap(cart) && sameKeySet(cart)) {
      applyJsonOnly(cart);
      return;
    }

    const freshRoot = await fetchSectionRoot();
    if (!freshRoot) return;

    const commit = () => {
      const currentRoot = root();
      if (!currentRoot) return;

      const currentEmpty = currentRoot.querySelector('.cart-drawer__empty');
      const freshEmpty = freshRoot.querySelector('.cart-drawer__empty');
      const currentItems = currentRoot.querySelector('.cart-drawer__items');
      const freshItems = freshRoot.querySelector('.cart-drawer__items');

      if ((currentEmpty && !currentItems) || (freshEmpty && !freshItems)) {
        currentRoot.innerHTML = freshRoot.innerHTML;
      } else {
        patchHeader(
          currentRoot.querySelector('.cart-drawer__header'),
          freshRoot.querySelector('.cart-drawer__header')
        );

        patchItems(currentItems, freshItems);

        patchSummary(
          currentRoot.querySelector('.cart-drawer__summary'),
          freshRoot.querySelector('.cart-drawer__summary')
        );
      }

      if (cart) {
        lastKnownCart = cart;
        syncGlobalBubble(cart);
        lastSectionSignature = cartSignature(cart);
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:rendered', {
        bubbles: true,
        detail: {
          cart: cart || null,
          mode: 'section-keyed-clean-final'
        }
      }));
    };

    if (options && options.preload) {
      await prewarmDrawerImages(freshRoot, options.imageTimeout || OPEN_IMAGE_PREWARM_TIMEOUT);
    }

    if (options && options.sync) {
      commit();
    } else {
      requestAnimationFrame(commit);
    }
  }

  async function prepareDrawerContentBeforeOpen(cart) {
    const r = root();

    if (!cart) {
      await prewarmDrawerImages(r, 120);
      return;
    }

    if (sameKeySet(cart) && !shouldUseFullEmptySwap(cart)) {
      applyJsonOnly(cart);
      await prewarmDrawerImages(r, 140);
      return;
    }

    await patchSection(cart, {
      sync: true,
      preload: true,
      opening: true,
      imageTimeout: OPEN_IMAGE_PREWARM_TIMEOUT
    });

    await prewarmDrawerImages(root(), 120);
  }

  function queueSectionPatch(cart, options) {
    const config = options || {};

    if (cart) queuedSectionCart = cart;
    if (config.open) queuedSectionOpen = true;

    clearTimeout(sectionPatchTimer);

    sectionPatchTimer = setTimeout(
      runQueuedSectionPatch,
      typeof config.delay === 'number' ? config.delay : STRUCTURE_PATCH_DELAY
    );
  }

  async function runQueuedSectionPatch() {
    if (sectionPatchRunning) {
      sectionPatchTimer = setTimeout(runQueuedSectionPatch, 120);
      return;
    }

    sectionPatchTimer = null;
    sectionPatchRunning = true;

    let cart = queuedSectionCart;
    const wasOpenEvent = queuedSectionOpen;

    queuedSectionCart = null;
    queuedSectionOpen = false;

    try {
      if (!cart) cart = await fetchCart();
      if (!cart) return;

      const signature = cartSignature(cart);

      if (signature && signature === lastSectionSignature && !wasOpenEvent) {
        applyJsonOnly(cart);
        return;
      }

      if (!shouldUseFullEmptySwap(cart) && sameKeySet(cart)) {
        applyJsonOnly(cart);
      } else {
        await patchSection(cart);
      }
    } catch (error) {
    } finally {
      sectionPatchRunning = false;

      if (queuedSectionCart || queuedSectionOpen) {
        queueSectionPatch(queuedSectionCart, {
          open: queuedSectionOpen
        });
      }
    }
  }

  function openDrawerImmediately() {
    if (window.LLCartDrawerLock && typeof window.LLCartDrawerLock.open === 'function') {
      window.LLCartDrawerLock.open();
      return;
    }

    const d = dialog();
    if (!d) return;

    if (!d.open) {
      d.setAttribute('aria-modal', 'false');
      try {
        if (typeof d.show === 'function') {
          d.show();
        } else {
          d.setAttribute('open', '');
        }
      } catch (error) {
        d.setAttribute('open', '');
      }
    }
  }

  function closeDrawerImmediately() {
    if (window.LLCartDrawerLock && typeof window.LLCartDrawerLock.close === 'function') {
      window.LLCartDrawerLock.close();
      return;
    }

    const d = dialog();
    if (!d) return;

    try {
      if (d.open && typeof d.close === 'function') {
        d.close();
      } else {
        d.removeAttribute('open');
      }
    } catch (error) {
      d.removeAttribute('open');
    }
  }

  function patchDrawerComponentOpen() {
    const component = drawerComponent();
    if (!component || component.__llCleanFinalOpenPatched) return;

    if (typeof component.open === 'function') {
      component.__llOriginalOpen = component.open.bind(component);
    }

    if (typeof component.close === 'function') {
      component.__llOriginalClose = component.close.bind(component);
    }

    component.open = function() {
      handleOpenLikeEvent({
        detail: {}
      });
    };

    component.close = function() {
      closeDrawerImmediately();
    };

    component.__llCleanFinalOpenPatched = true;
  }

  function currentQuantityFromWrap(wrap) {
    const display = wrap ? wrap.querySelector('.qty-inline-display') : null;
    return parseInt(((display && display.textContent) || '0').replace(/[^0-9-]/g, ''), 10) || 0;
  }

  function pulseQty(wrap, quantity) {
    const display = wrap ? wrap.querySelector('.qty-inline-display') : null;
    if (!display) return;

    setText(display, quantity);

    display.classList.remove('ll-qty-pulse');
    void display.offsetWidth;
    display.classList.add('ll-qty-pulse');
  }

  function setQtyPending(wrap, pending) {
    if (!wrap) return;

    wrap.classList.toggle('is-pending', !!pending);
    wrap.setAttribute('aria-busy', pending ? 'true' : 'false');

    wrap.querySelectorAll('.qty-inline-btn').forEach((button) => {
      button.disabled = !!pending;
    });
  }

  function setButtonPending(button, pending) {
    if (!button) return;

    button.disabled = !!pending;
    button.setAttribute('aria-busy', pending ? 'true' : 'false');
  }

  async function handleQtyClick(event, button) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const wrap = button.closest('.inline-qty-form');
    const itemKey = wrap ? wrap.getAttribute('data-item-key') : null;
    const delta = parseInt(button.getAttribute('data-delta') || '0', 10) || 0;

    if (!wrap || !itemKey || wrap.classList.contains('is-pending')) return;

    const current = currentQuantityFromWrap(wrap);
    const next = Math.max(0, current + delta);

    lastInteractionAt = Date.now();

    setQtyPending(wrap, true);

    if (next > 0) {
      pulseQty(wrap, next);
    }

    try {
      const cart = await changeQuantityDirect(itemKey, next);

      lastKnownCart = cart;

      if (next <= 0 || !getCartItem(cart, itemKey)) {
        removeRowsNotInCart(cart);

        if (Number(cart.item_count || 0) <= 0 || shouldUseFullEmptySwap(cart)) {
          queueSectionPatch(cart, {
            delay: 170
          });
        } else {
          applyJsonOnly(cart);
        }

        return;
      }

      applyJsonOnly(cart);
    } catch (error) {
      pulseQty(wrap, current);

      queueSectionPatch(null, {
        delay: 160
      });
    } finally {
      setQtyPending(wrap, false);
    }
  }

  async function handleRemoveClick(event, button) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const itemKey = button.getAttribute('data-remove-key');
    if (!itemKey || button.disabled) return;

    lastInteractionAt = Date.now();

    setButtonPending(button, true);

    try {
      const cart = await changeQuantityDirect(itemKey, 0);

      lastKnownCart = cart;
      removeRowsNotInCart(cart);

      if (Number(cart.item_count || 0) <= 0 || shouldUseFullEmptySwap(cart)) {
        queueSectionPatch(cart, {
          delay: 170
        });
      } else {
        applyJsonOnly(cart);
      }
    } catch (error) {
      queueSectionPatch(null, {
        delay: 120
      });
    } finally {
      setButtonPending(button, false);
    }
  }

  document.addEventListener('click', function(event) {
    const qtyButton = event.target.closest && event.target.closest('cart-drawer-component .inline-qty-form .qty-inline-btn');

    if (qtyButton) {
      handleQtyClick(event, qtyButton);
      return;
    }

    const removeButton = event.target.closest && event.target.closest('cart-drawer-component .remove-btn[data-remove-key]');

    if (removeButton) {
      handleRemoveClick(event, removeButton);
    }
  }, true);

  async function handleOpenLikeEvent(event) {
    const detail = event && event.detail ? event.detail : {};

    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    if (event && typeof event.stopPropagation === 'function') event.stopPropagation();

    if (event && typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    patchDrawerComponentOpen();

    const cart = detail.cart || null;

    if (isOpen()) {
      if (cart && sameKeySet(cart) && !shouldUseFullEmptySwap(cart)) {
        applyJsonOnly(cart);
      } else if (cart) {
        queueSectionPatch(cart, {
          delay: 320
        });
      }

      return;
    }

    /*
      STEP 65 HOTFIX — SAFE INSTANT MANUAL OPEN

      Beim normalen Klick auf das Warenkorb-Symbol gibt es kein Cart-Payload.
      In genau diesem Fall startet die bestehende Drawer-Motion SOFORT.
      Das bisherige Bild-Prewarm läuft danach weiter und blockiert die
      sichtbare Reaktion nicht mehr.

      Für Quick Add / Cart-Payloads bleibt der bisherige bewährte Ablauf
      vollständig erhalten, damit während der Öffnung keine Strukturwechsel
      erzwungen werden.
    */
    if (!cart) {
      openDrawerImmediately();

      try {
        await prepareDrawerContentBeforeOpen(null);
      } catch (error) {
      }

      return;
    }

    try {
      await prepareDrawerContentBeforeOpen(cart);
    } catch (error) {
    }

    openDrawerImmediately();
  }

  function handleRefreshLikeEvent(event) {
    const detail = event && event.detail ? event.detail : {};
    const cart = detail.cart || null;

    if (event && typeof event.stopPropagation === 'function') {
      event.stopPropagation();
    }

    if (event && typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (detail.open) {
      handleOpenLikeEvent({
        detail: detail
      });

      return;
    }

    if (cart && sameKeySet(cart) && !shouldUseFullEmptySwap(cart)) {
      applyJsonOnly(cart);
      return;
    }

    queueSectionPatch(cart, {
      delay: Date.now() - lastInteractionAt < 500 ? 180 : STRUCTURE_PATCH_DELAY
    });
  }

  function isFullCartPayload(payload) {
    return !!(
      payload &&
      typeof payload === 'object' &&
      Array.isArray(payload.items) &&
      typeof payload.item_count !== 'undefined'
    );
  }

  function isCartAddURL(value) {
    if (!value) return false;

    try {
      const url = new URL(String(value), window.location.origin);
      const pathname = url.pathname.replace(/\/+$/, '');

      return (
        pathname === '/cart/add' ||
        pathname === '/cart/add.js' ||
        pathname.endsWith('/cart/add') ||
        pathname.endsWith('/cart/add.js')
      );
    } catch (error) {
      const raw = String(value).split('?')[0].replace(/\/+$/, '');
      return (
        raw === '/cart/add' ||
        raw === '/cart/add.js' ||
        raw.endsWith('/cart/add') ||
        raw.endsWith('/cart/add.js') ||
        raw.indexOf('/cart/add') !== -1
      );
    }
  }

  function requestLooksLikeCartAdd(input, init) {
    const method = String(
      (init && init.method) ||
      (input && input.method) ||
      'GET'
    ).toUpperCase();

    if (method !== 'POST') return false;

    const url = typeof input === 'string' ? input : (input && input.url ? input.url : '');

    return isCartAddURL(url);
  }

  function formLooksLikeCartAdd(form) {
    if (!form || !form.matches || !form.matches('form')) return false;
    if (form.closest('cart-drawer-component')) return false;
    if (form.matches('[data-llr-form]')) return false;

    const action = form.getAttribute('action') || CART_ADD_URL || '/cart/add';
    if (!isCartAddURL(action)) return false;

    return !!(
      form.querySelector('[name="id"]') ||
      form.querySelector('[name^="items"]') ||
      form.querySelector('button[type="submit"], input[type="submit"], button:not([type])')
    );
  }

  function getSubmitter(event, form) {
    const submitter = event && event.submitter ? event.submitter : document.activeElement;

    if (
      submitter &&
      form &&
      form.contains(submitter) &&
      submitter.matches &&
      submitter.matches('button, input, [type="submit"]')
    ) {
      return submitter;
    }

    return form ? form.querySelector('button[type="submit"], input[type="submit"], button:not([type])') : null;
  }

  function buildFormData(form, submitter) {
    try {
      return submitter ? new FormData(form, submitter) : new FormData(form);
    } catch (error) {
      const data = new FormData(form);

      if (
        submitter &&
        submitter.name &&
        !submitter.disabled &&
        typeof submitter.value !== 'undefined'
      ) {
        data.append(submitter.name, submitter.value);
      }

      return data;
    }
  }

  async function readResponseJSON(response) {
    try {
      return await response.clone().json();
    } catch (error) {
      return null;
    }
  }

  let quickAddOpenTimer = null;
  let quickAddOpening = false;
  let quickAddQueuedCart = null;
  let quickAddInternalFetchDepth = 0;

  async function openAfterQuickAdd(cartCandidate) {
    quickAddOpenTimer = null;

    if (quickAddOpening) {
      quickAddQueuedCart = cartCandidate || quickAddQueuedCart;
      quickAddOpenTimer = setTimeout(() => openAfterQuickAdd(quickAddQueuedCart), 90);
      return;
    }

    quickAddOpening = true;

    try {
      let cart = isFullCartPayload(cartCandidate) ? cartCandidate : null;

      if (!cart) {
        cart = await fetchCart();
      }

      if (cart) {
        lastKnownCart = cart;
        syncGlobalBubble(cart);
      }

      await handleOpenLikeEvent({
        detail: {
          cart: cart || null
        }
      });
    } catch (error) {
      openDrawerImmediately();

      queueSectionPatch(null, {
        delay: 160
      });
    } finally {
      quickAddOpening = false;

      if (quickAddQueuedCart) {
        const queued = quickAddQueuedCart;
        quickAddQueuedCart = null;
        clearTimeout(quickAddOpenTimer);
        quickAddOpenTimer = setTimeout(() => openAfterQuickAdd(queued), 80);
      }
    }
  }

  function scheduleOpenAfterQuickAdd(cartCandidate, delay) {
    if (cartCandidate) quickAddQueuedCart = cartCandidate;

    clearTimeout(quickAddOpenTimer);

    quickAddOpenTimer = setTimeout(
      () => {
        const queued = quickAddQueuedCart;
        quickAddQueuedCart = null;
        openAfterQuickAdd(queued);
      },
      typeof delay === 'number' ? delay : 70
    );
  }

  function markButtonPending(button, pending) {
    if (!button) return;

    if (pending) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading', 'is-pending', 'll-quick-add-pending');

      if ('disabled' in button) {
        button.disabled = true;
      }
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading', 'is-pending', 'll-quick-add-pending');

      if ('disabled' in button) {
        button.disabled = false;
      }
    }
  }

  async function handleQuickAddFormSubmit(event, form) {
    const submitter = getSubmitter(event, form);

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (form.__llQuickAddSubmitting) return;

    form.__llQuickAddSubmitting = true;
    form.setAttribute('aria-busy', 'true');
    markButtonPending(submitter, true);

    lastInteractionAt = Date.now();

    try {
      const formData = buildFormData(form, submitter);

      quickAddInternalFetchDepth += 1;

      const response = await fetch(CART_ADD_URL || '/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      quickAddInternalFetchDepth = Math.max(0, quickAddInternalFetchDepth - 1);

      const addPayload = await readResponseJSON(response);

      if (!response.ok) {
        const message =
          (addPayload && (addPayload.description || addPayload.message || addPayload.status)) ||
          'Quick Add konnte nicht hinzugefügt werden.';

        throw new Error(message);
      }

      const cart = await fetchCart();

      document.dispatchEvent(new CustomEvent('ll:quick-add:added', {
        bubbles: true,
        detail: {
          cart: cart || null,
          item: addPayload || null
        }
      }));

      scheduleOpenAfterQuickAdd(cart, 0);
    } catch (error) {
      quickAddInternalFetchDepth = Math.max(0, quickAddInternalFetchDepth - 1);

      document.dispatchEvent(new CustomEvent('ll:quick-add:error', {
        bubbles: true,
        detail: {
          error: error,
          form: form
        }
      }));

      queueSectionPatch(null, {
        delay: 160
      });
    } finally {
      form.__llQuickAddSubmitting = false;
      form.removeAttribute('aria-busy');
      markButtonPending(submitter, false);
    }
  }

  function patchFetchCartAddBridge() {
    if (window.__LLQuickAddFetchBridgeCleanFinalV1 || typeof window.fetch !== 'function') return;

    const originalFetch = window.fetch.bind(window);

    window.fetch = function(input, init) {
      const shouldWatch = quickAddInternalFetchDepth <= 0 && requestLooksLikeCartAdd(input, init);
      const responsePromise = originalFetch(input, init);

      if (shouldWatch) {
        responsePromise
          .then(async (response) => {
            if (!response || !response.ok) return;

            const payload = await readResponseJSON(response);
            scheduleOpenAfterQuickAdd(isFullCartPayload(payload) ? payload : null, 90);
          })
          .catch(() => {});
      }

      return responsePromise;
    };

    window.__LLQuickAddFetchBridgeCleanFinalV1 = true;
  }

  function patchXHRCartAddBridge() {
    if (
      window.__LLQuickAddXHRBridgeCleanFinalV1 ||
      typeof window.XMLHttpRequest === 'undefined'
    ) {
      return;
    }

    const proto = window.XMLHttpRequest.prototype;
    const originalOpen = proto.open;
    const originalSend = proto.send;

    proto.open = function(method, url) {
      this.__llCartAddRequest = String(method || '').toUpperCase() === 'POST' && isCartAddURL(url);

      return originalOpen.apply(this, arguments);
    };

    proto.send = function() {
      if (this.__llCartAddRequest && quickAddInternalFetchDepth <= 0) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            scheduleOpenAfterQuickAdd(null, 120);
          }
        }, {
          once: true
        });
      }

      return originalSend.apply(this, arguments);
    };

    window.__LLQuickAddXHRBridgeCleanFinalV1 = true;
  }

  function handleAddLikeEvent(event) {
    const detail = event && event.detail ? event.detail : {};

    if (detail && detail.source === 'll-quick-add-bridge') return;

    if (detail && detail.open === false) return;

    scheduleOpenAfterQuickAdd(detail.cart || null, isFullCartPayload(detail.cart) ? 0 : 110);
  }

  document.addEventListener('submit', function(event) {
    const form = event.target;

    if (!formLooksLikeCartAdd(form)) return;

    handleQuickAddFormSubmit(event, form);
  }, true);

  [
    'cart:add',
    'cart:added',
    'cart:item-added',
    'cart:product-added',
    'ajaxProduct:added',
    'product:added',
    'product:added-to-cart',
    'theme:cart:add',
    'theme:cart:added',
    'quick-add:added',
    'quickadd:added'
  ].forEach((eventName) => {
    document.addEventListener(eventName, handleAddLikeEvent, true);
    window.addEventListener(eventName, handleAddLikeEvent, true);
  });

  patchFetchCartAddBridge();
  patchXHRCartAddBridge();

  ['cart:open', 'cart-drawer:open'].forEach((eventName) => {
    document.addEventListener(eventName, handleOpenLikeEvent, true);
    window.addEventListener(eventName, handleOpenLikeEvent, true);
  });

  ['cart:refresh', 'cart-drawer:refresh', 'cart:update', 'cart:updated'].forEach((eventName) => {
    document.addEventListener(eventName, handleRefreshLikeEvent, true);
    window.addEventListener(eventName, handleRefreshLikeEvent, true);
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest) return;

    const opener = event.target.closest(
      'a[href$="/cart"], a[href*="/cart?"], .header__icon--cart, .cart-icon-bubble, .ll-cart-toggle, [id^="ll-cart-button-"]'
    );

    if (!opener || opener.closest('cart-drawer-component')) return;

    const lucidCartButton = opener.matches('.ll-cart-toggle, [id^="ll-cart-button-"]')
      ? opener
      : opener.closest('.ll-cart-toggle, [id^="ll-cart-button-"]');

    if (lucidCartButton) {
      const trueHitbox = lucidCartButton.querySelector('.ll-cart-toggle__hitbox');
      const clickedRealCartIcon = trueHitbox
        ? trueHitbox.contains(event.target)
        : !!event.target.closest('svg, .ll-cart-count');

      if (!clickedRealCartIcon) return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    if (
      window.LLCartDrawerLock &&
      typeof window.LLCartDrawerLock.isOpen === 'function' &&
      window.LLCartDrawerLock.isOpen() &&
      typeof window.LLCartDrawerLock.close === 'function'
    ) {
      window.LLCartDrawerLock.close();
      return;
    }

    handleOpenLikeEvent({
      detail: {}
    });
  }, true);

  window.LLQueueCartDrawerRender = function(cart, options) {
    const config = options || {};

    if (config.open) {
      handleOpenLikeEvent({
        detail: {
          cart: cart || null
        }
      });

      return;
    }

    if (cart && sameKeySet(cart) && !shouldUseFullEmptySwap(cart)) {
      applyJsonOnly(cart);
    } else {
      queueSectionPatch(cart || null, {
        delay: config.delay || STRUCTURE_PATCH_DELAY
      });
    }
  };

  patchDrawerComponentOpen();

  window.addEventListener('DOMContentLoaded', patchDrawerComponentOpen);

  setTimeout(patchDrawerComponentOpen, 50);
  setTimeout(patchDrawerComponentOpen, 300);
})();

(function() {
  if (window.__LLWhatsAppDirectInit) return;
  window.__LLWhatsAppDirectInit = true;

  const LL_WHATSAPP_PHONE = '4917670020422';
  const LL_WHATSAPP_APP_URL = 'whatsapp://send?phone=' + LL_WHATSAPP_PHONE;
  const LL_WHATSAPP_WEB_URL = 'https://web.whatsapp.com/send?phone=' + LL_WHATSAPP_PHONE;

  function llIsMobileWhatsAppDevice() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest && e.target.closest('.ll-whatsapp-direct-link');
    if (!link) return;
    if (e.button && e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    if (llIsMobileWhatsAppDevice()) {
      window.location.href = LL_WHATSAPP_APP_URL;
    } else {
      window.open(LL_WHATSAPP_WEB_URL, '_blank', 'noopener');
    }
  }, true);
})();
